export default __webpack_public_path__ + "static/media/user-testing.55154253.svg";